<!-- Above the type-specific detail, because it is the reason this application is on a
     reviewer's screen rather than issued. canDecide gates it: the same component renders
     the applicant's magic-link view, and the API already strips these fields there - this
     is the second lock on the same door. -->
<!-- Short notice used to be a refusal on the form: an application inside the window
     never reached anyone. TLC asked for the opposite - "Change from auto-refusal to
     send for staff decision" - so it arrives like any other and this is the only thing
     that says it came in late. canDecide gates it for the same reason as the blacklist
     block below: on an issued permit the notice given is history, not a decision. -->
@if (canDecide && permit.shortNotice) {
    <div class="alert alert-warning d-flex align-items-start" role="alert">
        <i class="fa fa-clock me-3 mt-1"></i>
        <div>
            <strong>Short notice - {{ permit.shortNotice.given }} days, not {{ permit.shortNotice.required }}</strong>
            <p class="mb-1">
                This application arrived {{ permit.shortNotice.required - permit.shortNotice.given }} days inside the usual
                {{ permit.shortNotice.required }}-day window for a {{ permit.permitType }}.
            </p>
            <p class="small mb-0 text-body-secondary">
                It is yours to decide. Consultation, conditions and any cultural advisor arrangements still take the time they take - approve it if that can be
                done, or deny it and tell the applicant why.
            </p>
        </div>
    </div>
}
@if (canDecide && permit.travellingOutsideLocations) {
    <div class="alert alert-warning d-flex align-items-start" role="alert">
        <i class="fa fa-route me-3 mt-1"></i>
        <div>
            <strong>Travelling outside the selected locations</strong>
            <p class="mb-0 mt-1">
                The applicant said they will go beyond the locations on this permit - not just transit the main roads between them. Work or activity outside the
                listed communities is worth a closer look before you approve it.
            </p>
        </div>
    </div>
}
@if (canDecide && permit.blacklistFlagged) {
    <div class="alert alert-warning d-flex align-items-start" role="alert">
        <i class="fa fa-triangle-exclamation me-3 mt-1"></i>
        <div>
            <strong>Held for review - possible banned-list match</strong>
            <p class="mb-1">This application was not issued automatically{{ permit.blacklistFlaggedAt ? ' - held on ' + permit.blacklistFlaggedAt : '' }}.</p>
            <!-- Its own block, not folded into the sentence: it carries the reason staff
             typed when they added the name, which is the part a reviewer acts on and
             can run to several lines. -->
            @if (permit.blacklistMatchNote) {
                <p class="mb-1">
                    <strong>{{ permit.blacklistMatchNote }}</strong>
                </p>
            }
            <p class="small mb-0 text-body-secondary">
                A match is a name that looked similar, not a decision. Check whether this is the same person and approve or deny as normal - the applicant has
                not been told anything about this.
            </p>
        </div>
    </div>
}

<!-- Above the type detail and NOT gated on canDecide, unlike the blacklist banner:
     these conditions bind the person holding the permit, so they belong on their view
     of it as much as on a reviewer's. -->
@if (permit.specialConditions) {
    <div class="alert alert-info d-flex align-items-start" role="alert">
        <i class="fa fa-circle-exclamation me-3 mt-1"></i>
        <div>
            <strong>Special conditions</strong>
            <p class="mb-0 mt-1" style="white-space: pre-line">{{ permit.specialConditions }}</p>
        </div>
    </div>
}
@switch (permit.type) {
    @case ('tourist_pass') {
        <app-tourist-pass-detail [permit]="permit"></app-tourist-pass-detail>
    }
    @case ('recreation') {
        <app-recreation-detail [permit]="permit"></app-recreation-detail>
    }
    @case ('friends_family') {
        <app-friends-family-detail [permit]="permit"></app-friends-family-detail>
    }
    @case ('work') {
        <app-work-detail [permit]="permit"></app-work-detail>
    }
    @case ('media') {
        <app-media-detail [permit]="permit"></app-media-detail>
    }
    @case ('fishing') {
        <app-fishing-hunting-detail [permit]="permit" [canDecide]="canDecide" (decided)="decided.emit()"></app-fishing-hunting-detail>
    }
    @case ('hunting') {
        <app-fishing-hunting-detail [permit]="permit" [canDecide]="canDecide" (decided)="decided.emit()"></app-fishing-hunting-detail>
    }
    @case ('research') {
        <app-research-detail [permit]="permit"></app-research-detail>
    }
    @default {
        <app-permit-common-details [permit]="permit"></app-permit-common-details>
    }
}
